import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var videoServices = {
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  INSTAGRAM: 'instagram',
  VINE: 'vine',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
  GIF: 'gif',
  HTML5: 'html5',
  URL: 'url',
  MUX: 'mux'
};
videoServices.ALL = _valuesInstanceProperty(_).call(_, videoServices);
export default videoServices;
//# sourceMappingURL=video-services.js.map